import type { SelectProps } from "../Select/types";

export const hourTypes = [
    "regular",
    "overtime",
    "double-time",
    "double-time-and-half",
    "override",
    "amount",
    "unit",
    "unpaid",
    "pto",
    "holiday",
] as const;

export type HourType = typeof hourTypes[number];

type DistributiveOmit<T, K extends keyof any> = T extends any ? Omit<T, K> : never;

export type HourTypeSelectProps = DistributiveOmit<SelectProps<HourType>, "children">;
